import { render, staticRenderFns } from "./QuestionConfigModal.vue?vue&type=template&id=cae08012"
import script from "./QuestionConfigModal.vue?vue&type=script&lang=js"
export * from "./QuestionConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports